import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';

import { Container } from './styles/Container';

function FeeDetails({ description, value }) {
  return (
    <Container>
      <Box width={{ xs: '70%', md: '85%' }}>
        <Typography tag="span" variant="subtitle">{description}</Typography>
      </Box>
      <Typography tag="span" variant="subtitle">{value}</Typography>
    </Container>
  );
}

FeeDetails.propTypes = {
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default FeeDetails;
